import React from "react";
import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

function AdminPageHeader({ title, subtitle, action }: AdminPageHeaderProps) {
  const { instance } = useMsal();

  const handleLogout = async () => {
    const accounts = instance.getAllAccounts();
    const activeAccount = instance.getActiveAccount() ?? (accounts.length ? accounts[0] : null);

    if (!activeAccount) {
      await instance.logoutRedirect({
        postLogoutRedirectUri:
          process.env.REACT_APP_AZURE_REDIRECT_URI ||
          `${window.location.origin}/verified-kyc-users`,
      });
      return;
    }

    await instance.logoutRedirect({
      account: activeAccount,
      logoutHint:
        (activeAccount.idTokenClaims as Record<string, string>)?.login_hint ||
        activeAccount.username,
      postLogoutRedirectUri:
        process.env.REACT_APP_AZURE_REDIRECT_URI ||
        `${window.location.origin}/verified-kyc-users`,
    });
  };

  const userName =
    instance.getActiveAccount()?.name ||
    instance.getAllAccounts()[0]?.name ||
    instance.getAllAccounts()[0]?.username ||
    "";

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ bgcolor: "#fff" }}>
      <Toolbar sx={{ justifyContent: "space-between", gap: 2 }}>
        <Box>
          <Typography variant="h6" color="secondary.main" fontWeight={700}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {action}
          {userName && (
            <Typography variant="body2" color="text.secondary">
              {userName}
            </Typography>
          )}
          <Button variant="outlined" size="small" onClick={handleLogout}>
            Sign out
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default AdminPageHeader;
